<template>
    <div>
        <div class="d-flex align-items-start justify-content-between">
            <div>
                {{ item.name }}
            </div>
            <div>
                <pc-loader
                    v-bind:loading="downloading"
                    small>
                    <pc-button
                        small
                        v-on:click="onDownloadClicked(item.attachmentId)">
                        {{ downloadButton }}
                    </pc-button>
                </pc-loader>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "Forms/Components/Elements/i18n/eSignature.i18n.js";

    export default {
        props: {
            item: { type: Object, required: true },
            downloadCompletedItemFn: { type: Function, required: true }
        },
        data() {
            return {
                downloading: false
            };
        },
        computed: {
            ...mapI18n({ ...KEYS }, NAMESPACE)
        },
        methods: {
            async onDownloadClicked() {
                if (this.downloading) {
                    return;
                }
                try {
                    this.downloading = true;
                    await this.downloadCompletedItemFn({
                        attachmentId: this.item.attachmentId
                    });
                } finally {
                    this.downloading = false;
                }
            }
        }
    };
</script>
